import React from 'react';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Typography } from 'antd';
import { ReactComponent as TogetherSvg } from '../../../../assets/icons/together.svg';
import AddFamilyMemberForm from '../../../../components/mobile/sign-up/AddFamilyMemberForm';

const { Paragraph } = Typography;

const styles = {
  text1: {
    fontWeight: "700",
    fontSize: "20px",
    lineHeight: "28px",
    textAlign: "center",
    color: "#15A9E1"
  }
}

function MobileAddFamilyMemberScreen() {
  const { t } = useTranslation(['sign-up', 'common']);

  return (
    <>
      <Box display="flex" justifyContent="center">
        <TogetherSvg style={{ margin: '20', maxWidth: '80%' }} />
      </Box>
      <Box marginTop={30}>
        <Box marginBottom={30}>
          <Paragraph style={styles.text1}>
            {t('sign-up:guest.addFamiliMember')}
          </Paragraph>
        </Box>
        <AddFamilyMemberForm
          onSubmitBtnText={t('sign-up:guest.takeScreeningTest')}
        />
      </Box>
    </>
  );
}

export default MobileAddFamilyMemberScreen;
